module.exports = __webpack_public_path__ + "media/errors/internal_server_error-d6b05ced.gif";